import { TTrackEventData } from '@src/tracking/constant';

export const POSTALCODE_FILTER_EVENTS = {
  POSTALCODE_FILTER_TOGGLE: {
    component_name: 'post code filter',
    component_type: 'order',
    map_action: 'filter open',
    event: 'map_interaction',
  },
  POSTALCODE_SELECTION: {
    component_name: 'post code filter',
    component_type: 'order',
    map_action: 'filter select',
    event: 'map_interaction',
  },
};

export type TPostalCodeFilterToggle = TTrackEventData<{
  map_action: string;
  event: string;
}>;
export type TPostalCodeSelection = TTrackEventData<{
  map_action: string;
  event: string;
}>;
